import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { LentLabourListing } from './Pages'

export const LentLabourReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={LentLabourListing} />
    </Fragment>
)